import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { StateService } from '@/core/services/state.service';
import { AnfrageService } from '@/api/service-index';
import { AnfrageDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-display-model';
import { PortalContextService } from '@/core/services/portal-context.service';

@Injectable({
  providedIn: 'root'
})
export class GetAnfrageByIdResolver implements Resolve<AnfrageDisplayModel | undefined> {
  constructor(protected anfrageService: AnfrageService, protected stateService: StateService, protected portalContextService: PortalContextService){}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AnfrageDisplayModel | undefined> {
    let id: string = <string>route.params['id'];

    this.stateService.IsEndvalidationEnabled = false;

    if (this.portalContextService.CurrentAnfrage)
      return of(this.portalContextService.CurrentAnfrage);
      
    return this.anfrageService.apiAnfrageAnfrageIdGet({ anfrageId: id }).pipe(map(response => {
      if (response) {
        this.setCurrentAnfrage(response);

        if (this.portalContextService.CurrentAnfrage)
          return this.portalContextService.CurrentAnfrage;
      }
      
      return undefined;
    }));
  }

  public setCurrentAnfrage(anfrage: AnfrageDisplayModel): void
  {
    this.portalContextService.CurrentAnfrage = anfrage;
  }
}
